import PropTypes from 'prop-types';
import React from 'react';

import 'commons-forms/components/InputCheckbox/InputCheckbox.scss';

const InputCheckbox = ({ id, classNames, isSelected, label, value, valueChange }) => {
    const inputCheckboxClassNames = classNames;
    return (
        <div className="InputCheckbox">
            <div id={id} className={inputCheckboxClassNames.join(' ')}>
                <input
                    id={value}
                    type="checkbox"
                    name="checkbox"
                    value={value}
                    checked={isSelected}
                    onChange={() => valueChange(value)}
                />
                <label htmlFor={value} className="sr-text is-regular">
                    <span />
                    {label}
                </label>
            </div>
        </div>
    );
};

InputCheckbox.defaultProps = {
    id: '',
    classNames: [],
};

InputCheckbox.propTypes = {
    id: PropTypes.string,
    classNames: PropTypes.arrayOf(PropTypes.string),
    isSelected: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    valueChange: PropTypes.func.isRequired,
};

InputCheckbox.displayName = 'InputCheckbox';

export default InputCheckbox;



// WEBPACK FOOTER //
// ./src/components/InputCheckbox/InputCheckbox.jsx